import { postJson, fetchJson } from '~/core/ajax-json.js';

/**
 * @param {Function} method
 */
const xhr =
	method =>
	async (...args) => {
		try {
			const response = await method(...args);
			if (response.status !== 'SUCCESS') {
				throw new Error('Error updating marketing settings');
			}
			return response.result;
		} catch (err) {
			// eslint-disable-next-line no-console
			console.warn('Error while updating marketing communication settings');
			throw err;
		}
	};

/**
 *
 * @param {Object} updatedSettings
 */
const update = updatedSettings => postJson('/settings/updatemarketingsettings', updatedSettings);
const get = () => fetchJson('/settings/getmarketingsettings');

export const updateSettings = xhr(update);
export const getSettings = xhr(get);
